
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[gameId]/[locationSlug]/[drugSlug]",
      function () {
        return require("private-next-pages/[gameId]/[locationSlug]/[drugSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[gameId]/[locationSlug]/[drugSlug]"])
      });
    }
  